const modifyEventSponsor = function ({ commit }, { id, field, value }) {
  commit("MODIFY_EVENT_SPONSOR", { eventSponsorId: id, field, value });
};

export default modifyEventSponsor;
